/**
 * Customer web feature flags, parsed from VITE_FEATURE_* env vars.
 *
 * Referrals is OFF by default until the reward fulfilment path ships;
 * opt in per environment with VITE_FEATURE_REFERRALS="true". Inbox is
 * OFF by default until it has a real backend (the page is currently a
 * "Coming soon" stub); opt in per environment with
 * VITE_FEATURE_INBOX="true" once that feature is implemented.
 *
 * Blog and Promotions are OFF by default until real posts and offers exist
 * (redesign open items 7 and 13). While off, /blog and /promotions render the
 * 404 page and are left out of the navigation; opt in with
 * VITE_FEATURE_BLOG="true" / VITE_FEATURE_PROMOTIONS="true".
 */
export const featureFlags = {
  enableReferrals: import.meta.env.VITE_FEATURE_REFERRALS === "true",
  enableInbox: import.meta.env.VITE_FEATURE_INBOX === "true",
  enableBlog: import.meta.env.VITE_FEATURE_BLOG === "true",
  enablePromotions: import.meta.env.VITE_FEATURE_PROMOTIONS === "true",
} as const;

export type FeatureFlags = typeof featureFlags;
